import React from "react";

interface ToggleFormButtonProps {
  /** Optional text label shown to the left of the toggle */
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
}

export function ToggleFormButton({ label, checked, disabled, onChange, className, style }: ToggleFormButtonProps) {
  return (
    <label
      className={`toggle-form-btn${className ? ' ' + className : ''}`}
      style={style}
      onClick={e => e.stopPropagation()}
    >
      {label && <span className="toggle-form-btn__label">{label}</span>}
      <span className="toggle-form-btn__toggle">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={e => onChange(e.target.checked)}
        />
        <span className="toggle-form-btn__track">
          <span className="toggle-form-btn__thumb" />
        </span>
      </span>
    </label>
  );
}
